module.exports = __webpack_public_path__ + "img/file-earmark-zip.2ecf459c.svg";